import React from 'react';
import { Packages, EditIcon, DeleteRedIcon } from '../assets/icons';
import { ActionBox } from '../components/pages/receipt/ActionBox';
import { ActionBox2 } from '../components/pages/dispatch/ActionBox2';
import { ActionBox1 } from '../components/pages/manufacturing/fabricManufacturing/ActionBox1';
import { capitalize, getLocalStorageItem } from '../utils';
import { ActionBoxBills } from '../components/pages/bills/ActionBoxBills';
import { ActionBoxClear } from '../components/pages/manufacturing/ActionBoxClear';
import { LOCAL_STORAGE } from './constant';

export const PO_COLUMN = [
  {
    name: '',
    classNameTH: 'option-td',
    classNameTD: 'option-td',
    dataField: [''],
  },
  {
    name: '*',
    classNameTH: 'option-td',
    classNameTD: 'option-td',
    isCustom: true,
    dataField: ['invoice_status', 'bill_amount', 'name', 'currency_code', 'id'],
    customFormatter: ({ invoice_status, bill_amount, name, currency_code, id, func }) => {
      return (
        <div className=" w-100 h-100 d-flex">
          <input
            className={
              capitalize(invoice_status) !== 'To invoice' ? 'disable-check' : 'enable-check'
            }
            disabled={capitalize(invoice_status) !== 'To invoice'}
            type="checkbox"
            onChange={() => func.addPOToBill({ id, bill_amount, currency_code, name })}
            checked={func.checked(id, invoice_status)}
          />
        </div>
      );
    },
  },
  {
    name: 'Source ',
    classNameTH: 'option-td',
    classNameTD: 'option-td',
    dataField: ['origin'],
    canBeFiltered: false,
    valueType: 'String',
    sort: true,
  },
  {
    name: 'Container No',
    classNameTH: 'option-td',
    classNameTD: 'option-td',
    dataField: ['container_no'],
    canBeFiltered: false,
    valueType: 'String',
    sort: true,
  },
  {
    name: 'Invoice No',
    classNameTH: 'option-td',
    classNameTD: 'option-td',
    dataField: ['invoice_no'],
    canBeFiltered: false,
    valueType: 'String',
    sort: true,
  },
  {
    name: 'Lot No',
    classNameTH: 'option-td',
    classNameTD: 'option-td',
    dataField: ['lot'],
    valueType: 'Number',
    canBeFiltered: true,
    sort: true,
  },

  {
    name: 'Scheduled Date/Time',
    classNameTH: 'option-td',
    classNameTD: 'option-td',
    dataField: ['schedule_date'],
    canBeFiltered: false,
    sort: true,
  },
  {
    name: 'Bill Status',
    classNameTH: '',
    isCustom: true,
    classNameTD: 'option-td',
    dataField: ['invoice_status'],
    canBeFiltered: true,
    customFormatter: ({ invoice_status }) => {
      return (
        <div
          className={`col-${invoice_status === 'No' ? 'waiting' : invoice_status === 'Invoiced' ? 'received' : 'dispatched'} pills col-received d-flex ps-2 justify-content-center status-pills`}>
          <p>{invoice_status}</p>
        </div>
      );
    },
  },
  {
    name: 'Qty Status',
    classNameTH: '',
    isCustom: true,
    classNameTD: 'option-td',
    dataField: ['receipt_status'],
    canBeFiltered: true,
    customFormatter: ({ receipt_status }) => {
      return (
        <div
          className={`col-${receipt_status === 'Pending' ? 'waiting' : receipt_status === 'Full' ? 'received' : 'dispatched'} pills col-received d-flex ps-2 justify-content-center status-pills`}>
          <p>{receipt_status}</p>
        </div>
      );
    },
  },
];

export const LOGS_COLUMN = [
  {
    name: '',
    classNameTH: 'option-td',
    classNameTD: 'option-td',
    dataField: [''],
  },
  {
    name: 'Invoice No',
    classNameTH: 'option-td',
    classNameTD: 'option-td',
    dataField: ['invoice_number'],
    valueType: 'String',
    sort: true,
    canBeFiltered: false
  },
  {
    name: 'Date',
    classNameTH: 'option-td',
    classNameTD: 'option-td',
    dataField: ['date'],
    canBeFiltered: false,
    sort: true,
  },
  {
    name: 'Total Quantity',
    classNameTH: 'option-td',
    classNameTD: 'option-td',
    dataField: ['total_quantity'],
    valueType: 'Number',
    canBeFiltered: false,
    sort: true,
    showFull: true,
  },
  {
    name: 'Total Body Produced',
    classNameTH: 'option-td',
    classNameTD: 'option-td',
    dataField: ['total_body_produced'],
    valueType: 'Number',
    canBeFiltered: false,
    sort: true,
    showFull: true,
  },
  {
    name: 'Total Rib Produced',
    classNameTH: 'option-td',
    classNameTD: 'option-td',
    dataField: ['total_rib_produced'],
    valueType: 'Number',
    canBeFiltered: false,
    sort: true,
    showFull: true,
  },
  {
    name: 'Total Qty Produced',
    classNameTH: 'option-td',
    classNameTD: 'option-td',
    dataField: ['total_quantity_produced'],
    valueType: 'Number',
    canBeFiltered: false,
    sort: true,
    showFull: true,
  },
  {
    name: 'Total Damages',
    classNameTH: 'option-td',
    classNameTD: 'option-td',
    dataField: ['total_damages'],
    valueType: 'Number',
    canBeFiltered: false,
    sort: true,
  },
  {
    name: 'Status',
    classNameTH: 'option-td',
    classNameTD: 'option-td text-center',
    dataField: ['status'],
    isCustom: true,
    canBeFiltered: true,
    customFormatter: ({ status }) => {
      const statusMap = {
        Done: 'dispatched',
        Started: 'received',
        Pending: 'waiting',
      };
      const statusClass = statusMap[status];
      return (
        <div className={`pills col-${statusClass} d-flex ps-2 justify-content-center status-pills`}>
          <p>{status}</p>
        </div>
      );
    },
  },
];

export const LOGS_DETAIL_COLUMN = [
  {
    name: '',
    classNameTH: 'option-td',
    classNameTD: 'option-td',
    dataField: [''],
  },
  {
    name: 'Product',
    classNameTH: 'option-td',
    classNameTD: 'option-td',
    dataField: ['product'],
    valueType: 'String',
    sort: true,
    canBeFiltered: false,
    showFull: true,
  },
  {
    name: 'Size',
    classNameTH: 'option-td',
    classNameTD: 'option-td',
    dataField: ['size'],
    valueType: 'String',
    sort: true,
    canBeFiltered: false,
    showFull: true,
  },
  {
    name: 'Color',
    classNameTH: 'option-td',
    classNameTD: 'option-td',
    dataField: ['color'],
    valueType: 'String',
    sort: true,
    canBeFiltered: false,
    showFull: true,
  },
  {
    name: 'Invoice No',
    classNameTH: 'option-td',
    classNameTD: 'option-td',
    dataField: ['invoice_number'],
    valueType: 'String',
    sort: true,
    canBeFiltered: false,
    showFull: true,
  },
  {
    name: 'Lot',
    classNameTH: 'option-td',
    classNameTD: 'option-td',
    dataField: ['lot'],
    valueType: 'String',
    sort: true,
    canBeFiltered: false,
    showFull: true,
  },
  {
    name: 'Date',
    classNameTH: 'option-td',
    classNameTD: 'option-td',
    dataField: ['date'],
    canBeFiltered: false,
    sort: true,
  },
  {
    name: 'Quantity',
    classNameTH: 'option-td',
    classNameTD: 'option-td',
    dataField: ['quantity'],
    valueType: 'Integer',
    sort: true,
    canBeFiltered: false,
    showFull: true,
  },
  {
    name: 'Damage Qty',
    classNameTH: 'option-td',
    classNameTD: 'option-td',
    dataField: ['damage_quantity'],
    valueType: 'Integer',
    sort: true,
    canBeFiltered: false,
    showFull: true,
  },
  {
    name: 'Message',
    classNameTH: 'option-td',
    classNameTD: 'option-td',
    dataField: ['message'],
    valueType: 'String',
    showFull: true,
  },
  {
    name: 'Status',
    classNameTH: 'option-td',
    classNameTD: 'option-td text-center',
    dataField: ['status'],
    isCustom: true,
    canBeFiltered: true,
    customFormatter: ({ status }) => {
      const statusMap = {
        Success: 'dispatched',
        Failure: 'waiting',
      };
      const statusClass = statusMap[status];
      return (
        <div className={`pills col-${statusClass} d-flex ps-2 justify-content-center status-pills`}>
          <p>{status}</p>
        </div>
      );
    },
  },
];

export const BILL_GENERATION_COLUMN = [
  {
    name: '',
    classNameTH: 'product-td',
    classNameTD: 'product-td text-center',
    dataField: [''],
  },
  {
    name: 's/n',
    classNameTH: 'product-td',
    isCustom: true,
    classNameTD: 'product-td text-center',
    dataField: ['rowIndex'],
    customFormatter: ({ rowIndex }) => {
      return (
        <div className="d-flex justify-content-start mt-3 align-items-center">
          <p>{rowIndex + 1}</p>
        </div>
      );
    },
  },
  {
    name: 'Ref',
    classNameTH: 'product-td',
    classNameTD: 'product-td text-center',
    dataField: ['name'],
  },
  {
    name: 'Amount',
    classNameTH: 'quantity-td',
    classNameTD: 'quantity-td text-center',
    isCustom: true,
    valueType: 'Number',
    dataField: ['amount', 'currency_code'],
    customFormatter: ({ amount, currency_code }) => {
      return (
        <div className="d-flex justify-content-start mt-3 align-items-center">
          <p>{`${amount?.toFixed(2)} ${currency_code}`}</p>
        </div>
      );
    },
  },
  {
    name: 'Action',
    classNameTH: 'quantity-td',
    classNameTD: 'quantity-td text-center',
    isCustom: true,
    valueType: 'Number',
    dataField: ['id'],
    customFormatter: ({ func, id }) => {
      return (
        <div onClick={() => func(id)} className="d-flex justify-content-start">
          <DeleteRedIcon />
        </div>
      );
    },
  },
];

export const PO_DETAILS_COLUMN = [
  {
    name: '',
    classNameTH: 'product-td',
    classNameTD: 'product-td text-center',
    dataField: [''],
  },
  {
    name: 'Product',
    classNameTH: 'product-td',
    classNameTD: 'product-td text-center',
    dataField: ['product'],
    showFull: true
  },
  {
    name: 'Size',
    classNameTH: 'product-td',
    classNameTD: 'product-td text-center',
    dataField: ['variant_size'],
    valueType: 'Size',
    sort: true,
  },
  {
    name: 'Color',
    classNameTH: 'product-td',
    classNameTD: 'product-td text-center',
    dataField: ['variant_color'],
    valueType: 'String',
    sort: true,
  },
  {
    name: 'Lot No',
    classNameTH: 'product-td',
    classNameTD: 'product-td text-center',
    dataField: ['lot_no'],
    valueType: 'Number',
    sort: true,
  },
  {
    name: 'Demand',
    classNameTH: 'quantity-td',
    classNameTD: 'quantity-td text-center',
    sort: true,
    valueType: 'Number',
    dataField: ['qty'],
  },
  {
    name: 'Produced',
    classNameTH: 'quantity-td',
    classNameTD: 'quantity-td text-center',
    sort: true,
    valueType: 'Number',
    dataField: ['produced_qty'],
  },
  {
    name: 'Delivered',
    classNameTH: 'received-td',
    classNameTD: 'received-td text-center',
    dataField: ['received'],
    valueType: 'Number',
    sort: true,
  },
  {
    name: 'Rolls',
    classNameTH: 'received-td',
    classNameTD: 'received-td text-center',
    dataField: ['rolls'],
    valueType: 'Number',
    sort: true,
  },
  {
    name: 'Undelivered',
    classNameTH: 'undelivered-td',
    classNameTD: 'undelivered-td text-center',
    sort: true,
    valueType: 'Number',
    dataField: ['balance'],
  },
  {
    name: 'Billed',
    classNameTH: 'billed-td',
    classNameTD: 'billed-td text-center',
    sort: true,
    valueType: 'Number',
    dataField: ['billed'],
  },
  {
    name: 'UoM',
    classNameTH: 'uom-td',
    classNameTD: 'uom-td text-center',
    dataField: ['uom'],
  },
  {
    name: 'Unit Price',
    classNameTH: 'unit-price-td',
    classNameTD: 'unit-price-td text-center',
    sort: true,
    valueType: 'Number',
    dataField: ['unit_price'],
  },
  {
    name: 'Taxes',
    classNameTH: 'taxes-td',
    classNameTD: 'taxes-td text-center',
    dataField: ['tax'],
    valueType: 'Number',
    sort: true,
  },
];

export const RECEIPT_COLUMN = [
  {
    name: '',
    classNameTH: 'option-td',
    classNameTD: 'option-td',
    dataField: [''],
  },
  {
    name: '*',
    classNameTH: 'option-td',
    classNameTD: 'option-td',
    isCustom: true,
    dataField: ['id', 'state', 'contact', 'fill_received_quantity', 'received_quantity_filled'],
    customFormatter: ({ id, state, func, contact, fill_received_quantity, received_quantity_filled }) => {
      const isDisabled = (
        (state === 'Done' || state === 'Cancel' || state === 'Confirmed') ||
        (fill_received_quantity ? !received_quantity_filled : false)
      );
      return (
        <div className="w-100 h-100 d-flex">
          <input
            className={
              isDisabled ? 'disable-check' : 'enable-check'
            }
            type="checkbox"
            onChange={() => func.addBulkReceipts({ id, contact })}
            disabled={isDisabled}
            checked={func.checked(id, isDisabled)}
          />
        </div>
      );
    }
  },
  {
    name: 'Source',
    classNameTH: 'option-td',
    classNameTD: 'option-td',
    sort: true,
    valueType: 'String',
    dataField: ['source_document'],
    canBeFiltered: true,
  },
  {
    name: 'Lot No',
    classNameTH: 'option-td',
    classNameTD: 'checkbox-td text-center',
    dataField: ['lot'],
    sort: true,
    valueType: 'String',
    canBeFiltered: true,
  },
  {
    name: 'Backorder Of',
    classNameTH: 'option-td',
    classNameTD: 'checkbox-td text-center',
    dataField: ['backorder_of'],
    sort: true,
    valueType: 'String',
    canBeFiltered: true,
  },
  {
    name: 'Invoice No',
    classNameTH: 'option-td',
    classNameTD: 'checkbox-td text-center',
    dataField: ['invoice_no'],
    valueType: 'String',
    canBeFiltered: true,
    sort: true,
  },
  {
    name: 'Container No',
    classNameTH: 'option-td',
    classNameTD: 'checkbox-td text-center',
    dataField: ['physical_container_no'],
    valueType: 'String',
    canBeFiltered: true,
    sort: true,
  },
  {
    name: 'Contact',
    classNameTH: 'option-td',
    classNameTD: 'option-td',
    dataField: ['contact'],
    canBeFiltered: false,
  },
  {
    name: 'Scheduled Date',
    classNameTH: 'option-td',
    classNameTD: 'option-td',
    dataField: ['schedule_date'],
    canBeFiltered: false,
    sort: true,
  },
  {
    name: 'Finished Product',
    classNameTH: 'option-td',
    classNameTD: 'option-td',
    sort: true,
    valueType: 'String',
    dataField: ['finished_product'],
  },
  {
    name: 'Status',
    classNameTH: 'option-td',
    isCustom: true,
    classNameTD: 'option-td',
    dataField: ['state'],
    canBeFiltered: true,
    customFormatter: ({ state }) => {
      const statusClass = state === 'Done' ? 'received' : 'dispatched';
      return (
        <div className={`pills col-${statusClass} d-flex ps-2 justify-content-center status-pills`}>
          <p>{state}</p>
        </div>
      );
    },
  },
];

export const RECEIPT_INNER_COLUMN = [
  {
    name: '',
    classNameTH: 'option-td',
    classNameTD: 'option-td',
    dataField: [''],
  },
  {
    name: 'Product',
    classNameTH: 'product-td',
    classNameTD: 'product-td text-center',
    dataField: ['product'],
    showFull: true
  },
  {
    name: 'Lot No',
    classNameTH: 'lotNo-td',
    classNameTD: 'lotNo-td text-center',
    sort: true,
    valueType: 'String',
    dataField: ['lotNo'],
  },
  {
    name: 'Demand Quantity',
    classNameTH: 'demand-quantity-td',
    classNameTD: 'demand-quantity-td text-center',
    sort: true,
    valueType: 'Number',
    dataField: ['demand_quantity'],
  },
  {
    name: 'Shipped by ESUN',
    classNameTH: 'demand-quantity-td',
    classNameTD: 'demand-quantity-td text-center',
    sort: true,
    valueType: 'Number',
    dataField: ['shipped_by_esun'],
  },
  {
    name: 'Received Quantity',
    classNameTH: 'received-quantity-td',
    classNameTD: 'received-quantity-td text-center',
    sort: true,
    valueType: 'Number',
    dataField: ['received_quantity'],
  },
  {
    name: 'Damaged Quantity',
    classNameTH: 'received-quantity-td',
    classNameTD: 'received-quantity-td text-center',
    sort: true,
    valueType: 'Number',
    dataField: ['damaged_quantity'],
  },
  {
    name: 'Dispatched Quantity',
    classNameTH: 'received-quantity-td',
    classNameTD: 'received-quantity-td text-center',
    sort: true,
    valueType: 'Number',
    dataField: ['dispatched_quantity'],
  },
  {
    name: 'Total Damaged Quantity',
    classNameTH: 'received-quantity-td',
    classNameTD: 'received-quantity-td text-center',
    sort: true,
    valueType: 'Number',
    dataField: ['total_damaged_quantity'],
  },
  {
    name: 'Demand Rolls',
    classNameTH: 'received-quantity-td',
    classNameTD: 'received-quantity-td text-center',
    sort: true,
    valueType: 'Number',
    dataField: ['rolls'],
  },
  {
    name: 'Received Rolls',
    classNameTH: 'received-quantity-td',
    classNameTD: 'received-quantity-td text-center',
    sort: true,
    valueType: 'Number',
    dataField: ['done_rolls'],
  },
  {
    name: 'Unit',
    classNameTH: 'unit-td',
    classNameTD: 'unit-td text-center',
    dataField: ['unit'],
  },
  {
    name: 'Action',
    classNameTH: 'actions-td',
    classNameTD: 'actions-td text-center',
    dataField: [
      'received_quantity',
      'lotNo',
      'showEdit',
      'id',
      'tracking',
      'state',
      'rolls',
      'damaged_quantity',
    ],
    isCustom: true,
    customFormatter: ({
      showEdit,
      state,
      id,
      lotNo,
      received_quantity,
      popUp,
      setPopUp,
      setPopUpData,
      tracking,
      rolls,
      damaged_quantity,
    }) => {
      return (
        <>
          {
            (state === 'Assigned' || state === 'Confirmed') ? 
            (<ActionBox
              id={id}
              state={state}
              setPopUpData={setPopUpData}
              showEdit={showEdit}
              received_quantity={received_quantity}
              popUp={popUp}
              setPopUp={setPopUp}
              lotNo={lotNo}
              tracking={tracking}
              rolls={rolls}
              damaged_quantity={damaged_quantity}
            />) : '-'
          }
        </>
      );
    },
  },
];

export const FABRIC_DISPATCH_INNER_COLUMN = [
  {
    name: '',
    classNameTH: 'option-td',
    classNameTD: 'option-td',
    dataField: [''],
  },
  {
    name: 'Product',
    classNameTH: 'product-td',
    classNameTD: 'product-td text-center',
    dataField: ['product'],
    showFull: true
  },
  {
    name: 'Lot No',
    classNameTH: 'lotno-td',
    classNameTD: 'lotno-td text-center',
    sort: true,
    valueType: 'String',
    dataField: ['lotno'],
  },
  {
    name: 'Size',
    classNameTH: 'lotno-td',
    classNameTD: 'lotno-td text-center',
    dataField: ['size'],
    valueType: 'Number',
    sort: true,
  },
  {
    name: 'Color',
    classNameTH: 'lotno-td',
    classNameTD: 'lotno-td text-center',
    dataField: ['color'],
    valueType: 'String',
    sort: true,
  },
  {
    name: 'Demand Quantity',
    classNameTH: 'demand-quantity-td',
    classNameTD: 'demand-quantity-td text-center',
    sort: true,
    valueType: 'Number',
    dataField: ['demand_quantity'],
  },
  {
    name: 'Quantity',
    classNameTH: 'producing-quantity-td',
    classNameTD: 'producing-quantity-td text-center',
    sort: true,
    valueType: 'Number',
    dataField: ['producing_quantity'],
  },
  {
    name: 'Rolls',
    classNameTH: 'received-quantity-td',
    classNameTD: 'received-quantity-td text-center',
    sort: true,
    valueType: 'Number',
    dataField: ['rolls'],
  },
  {
    name: 'Damaged Quantity',
    classNameTH: 'received-quantity-td',
    classNameTD: 'received-quantity-td text-center',
    sort: true,
    valueType: 'Number',
    dataField: ['damaged_quantity'],
  },
  {
    name: 'Total Damaged Quantity',
    classNameTH: 'received-quantity-td',
    classNameTD: 'received-quantity-td text-center',
    sort: true,
    valueType: 'Number',
    dataField: ['total_damaged_quantity'],
  },
  {
    name: 'Unit',
    classNameTH: 'unit-td',
    classNameTD: 'unit-td text-center',
    dataField: ['unit'],
  },
  {
    name: 'Action',
    classNameTH: 'actions-td',
    classNameTD: 'actions-td text-center',
    dataField: ['move_id', 'producing_quantity', 'demand_quantity', 'damaged_quantity'],
    isCustom: true,
    customFormatter: ({
      id,
      demand_quantity,
      producing_quantity,
      move_id,
      damaged_quantity,
      popUp,
      setPopUp,
      setPopUpData,
    }) => {
      return (
        <>
          <ActionBox2
            id={id}
            setPopUpData={setPopUpData}
            demand_quantity={demand_quantity}
            producing_quantity={producing_quantity}
            damaged_quantity={damaged_quantity}
            popUp={popUp}
            setPopUp={setPopUp}
            move_id={move_id}
          />
        </>
      );
    },
  },
];

export const YARN_DISPATCH_INNER_COLUMN = [
  {
    name: '',
    classNameTH: 'option-td',
    classNameTD: 'option-td',
    dataField: [''],
  },
  {
    name: 'Product',
    classNameTH: 'product-td',
    classNameTD: 'product-td text-center',
    dataField: ['product'],
    showFull: true
  },
  {
    name: 'Lot No',
    classNameTH: 'lotno-td',
    classNameTD: 'lotno-td text-center',
    sort: true,
    valueType: 'String',
    dataField: ['lotno'],
  },
  {
    name: 'Demand Quantity',
    classNameTH: 'demand-quantity-td',
    classNameTD: 'demand-quantity-td text-center',
    sort: true,
    valueType: 'Number',
    dataField: ['demand_quantity'],
  },
  {
    name: 'Shipped by ESUN',
    classNameTH: 'demand-quantity-td',
    classNameTD: 'demand-quantity-td text-center',
    sort: true,
    valueType: 'Number',
    dataField: ['shipped_by_esun'],
  },
  {
    name: 'Done Quantity',
    classNameTH: 'producing-quantity-td',
    classNameTD: 'producing-quantity-td text-center',
    sort: true,
    valueType: 'Number',
    dataField: ['producing_quantity'],
  },
  {
    name: 'Rolls',
    classNameTH: 'producing-quantity-td',
    classNameTD: 'producing-quantity-td text-center',
    sort: true,
    valueType: 'String',
    dataField: ['rolls'],
  },
  {
    name: 'Damaged Quantity',
    classNameTH: 'producing-quantity-td',
    classNameTD: 'producing-quantity-td text-center',
    sort: true,
    valueType: 'Number',
    dataField: ['damaged_quantity'],
  },
  {
    name: 'Total Damaged Quantity',
    classNameTH: 'producing-quantity-td',
    classNameTD: 'producing-quantity-td text-center',
    sort: true,
    valueType: 'Number',
    dataField: ['total_damaged_quantity'],
  },
  {
    name: 'Unit',
    classNameTH: 'unit-td',
    classNameTD: 'unit-td text-center',
    dataField: ['unit'],
  },
  {
    name: 'Action',
    classNameTH: 'actions-td',
    classNameTD: 'actions-td text-center',
    dataField: [
      'producing_quantity',
      'lotno',
      'move_id',
      'tracking',
      'unit',
      'demand_quantity',
      'product',
      'damaged_quantity',
    ],
    isCustom: true,
    customFormatter: ({
      unit,
      move_id,
      product,
      demand_quantity,
      tracking,
      popUp,
      setPopUp,
      setPopUpData,
      lotno,
      producing_quantity,
      damaged_quantity,
    }) => {
      return (
        <ActionBox2
          unit={unit}
          move_id={move_id}
          product={product}
          setPopUpData={setPopUpData}
          demand_quantity={demand_quantity}
          tracking={tracking}
          popUp={popUp}
          setPopUp={setPopUp}
          lotno={lotno}
          producing_quantity={producing_quantity}
          damaged_quantity={damaged_quantity}
        />
      );
    },
  },
];

export const PACKAGE_COLUMN = [
  {
    name: '',
    classNameTH: 'option-td',
    classNameTD: 'option-td',
    dataField: [''],
  },
  {
    name: 'Package No',
    classNameTH: 'package-no-th',
    classNameTD: 'package-no-td text-center',
    dataField: ['package_no'],
    sort: true,
    valueType: 'String',
  },
  {
    name: 'Box Count',
    classNameTH: 'box-count-th',
    classNameTD: 'box-count-td text-center',
    dataField: ['box_count'],
    sort: true,
    valueType: 'Number',
  },
  {
    name: 'Packaging Date',
    classNameTH: 'packaging-date-th',
    classNameTD: 'packaging-date-td',
    dataField: ['packaging_date'],
  },
  {
    name: 'Dispatch Date',
    classNameTH: 'dispatch-date-th',
    classNameTD: 'dispatch-date-td',
    dataField: ['dispatch_date'],
  },
  {
    name: 'Status',
    classNameTH: 'option-td',
    classNameTD: 'option-td',
    dataField: ['status'],
    customFormatter: ({ status }) => {
      return <div>{status}</div>;
    },
  },
];

export const DISPATCH_COLUMN = [
  {
    name: '',
    classNameTH: 'option-td',
    classNameTD: 'option-td',
    dataField: [''],
  },
  {
    name: '*',
    classNameTH: 'option-td',
    classNameTD: 'option-td',
    isCustom: true,
    dataField: ['id', 'box_count', 'shipment_no', 'invoice_no', 'dispatch_status', 'vendor_type', 'user_type', 'dispatch_bill_id'],
    customFormatter: ({
      id,
      box_count,
      shipment_no,
      invoice_no,
      dispatch_status,
      vendor_type,
      user_type,
      dispatch_bill_id,
      func,
    }) => {
      const isDraft = capitalize(dispatch_status) === 'Draft';
      const isDyeing = vendor_type === 'dyeing';
      const isFabric = user_type === 'fabric';
      const isUserTypeDyeing = user_type === 'dyeing';
      const isTexshann = getLocalStorageItem(LOCAL_STORAGE.USERNAME) === 'TEXSHANN EXPORTS';
      const enable_check = isDraft && (isDyeing || isFabric || isUserTypeDyeing || isTexshann);
      const isDispatched = capitalize(dispatch_status) === 'Dispatched' || capitalize(dispatch_status) === 'Received';
      const canCreateBill = (dispatch_bill_id === 'N/A' && isDispatched);
      const isESUN = getLocalStorageItem(LOCAL_STORAGE.VENDOR_TYPE) === 'clothing';
      const canPrintList = !isESUN || (isESUN && (isDyeing || isUserTypeDyeing))


      if (func.isBillMode()) {
        // const showCheckbox =
        //   (isDraft && isDyeing && !isFabric) || (isDraft && isFabric);

        // if (showCheckbox) {
        return (
          <div className="w-100 h-100 d-flex">
            <input
              className={
                enable_check
                  ? 'enable-check'
                  : 'disable-check'
              }
              disabled={!enable_check}
              type="checkbox"
              onChange={() =>
                func.addPOToBill({ id, box_count, shipment_no, invoice_no, dispatch_status })
              }
              checked={func.checked(id, enable_check)}
            />
          </div>
        );
        // } else {
        //   return <div className="d-flex align-items-center">-</div>;
        // }
      }

      if (func.isPrintMode()) {
        return (
          <div className="w-100 h-100 d-flex">
            <input
              className={
                canPrintList
                  ? 'enable-check'
                  : 'disable-check'
              }
              disabled={!canPrintList}
              type="checkbox"
              onChange={() =>
                func.addPOToBill({ id, box_count, shipment_no, invoice_no, dispatch_status })
              }
              checked={func.checked(id, canPrintList)}
            />
          </div>
        );
      }

      if (func.isCreateBillMode()) {
        return (
          <div className="w-100 h-100 d-flex">
            <input
              className={
                canCreateBill
                  ? 'enable-check'
                  : 'disable-check'
              }
              disabled={!canCreateBill}
              type="checkbox"
              onChange={() =>
                func.addPOToBill({ id, dispatch_status })
              }
              checked={func.checked(id, canCreateBill)}
            />
          </div>
        );
      }

      return <div className="d-flex align-items-center">-</div>;
    },
  },
  {
    name: 'Source',
    classNameTH: 'option-th',
    classNameTD: 'option-td',
    sort: true,
    valueType: 'String',
    dataField: ['origin'],
  },
  {
    name: 'Lot No',
    classNameTH: 'option-th',
    classNameTD: 'option-td',
    valueType: 'String',
    sort: true,
    dataField: ['lot'],
  },
  {
    name: 'Lot Color',
    classNameTH: 'option-th',
    classNameTD: 'option-td',
    isCustom: false,
    dataField: ['lot_color'],
    valueType: 'String',
    sort: true,
  },
  {
    name: 'Lot Size',
    classNameTH: 'option-th',
    classNameTD: 'option-td',
    isCustom: false,
    dataField: ['lot_size'],
    valueType: 'String',
    sort: true,
  },
  {
    name: 'Rib Color',
    classNameTH: 'option-th',
    classNameTD: 'option-td',
    isCustom: false,
    dataField: ['rib_color'],
    valueType: 'String',
    sort: true,
  },
  {
    name: 'Rib Size',
    classNameTH: 'option-th',
    classNameTD: 'option-td',
    isCustom: false,
    dataField: ['rib_size'],
    valueType: 'String',
    sort: true,
  },
  {
    name: 'Backorder Of',
    classNameTH: 'option-th',
    classNameTD: 'option-td',
    valueType: 'String',
    sort: true,
    dataField: ['backorder_of'],
  },
  {
    name: 'Invoice No',
    classNameTH: 'option-th',
    classNameTD: 'option-td',
    valueType: 'String',
    dataField: ['invoice_no'],
    sort: true,
  },
  {
    name: 'Container No',
    classNameTH: 'option-td',
    classNameTD: 'checkbox-td text-center',
    dataField: ['physical_container_no'],
    valueType: 'String',
    canBeFiltered: true,
    sort: true,
  },
  {
    name: 'Contact',
    classNameTH: 'option-th',
    classNameTD: 'option-td',
    dataField: ['contact'],
  },
  {
    name: 'Finished Product',
    classNameTH: 'option-td',
    classNameTD: 'option-td',
    sort: true,
    valueType: 'String',
    dataField: ['finished_product'],
  },
  {
    name: 'Shipment Date',
    classNameTH: 'option-th',
    classNameTD: 'option-td',
    dataField: ['shipment_date'],
    sort: true,
  },
  {
    name: 'Box Count',
    classNameTH: 'option-th',
    classNameTD: 'option-td',
    dataField: ['box_count'],
    sort: true,
    valueType: 'Number',
  },
  {
    name: 'Bill Status',
    classNameTH: 'pe-2',
    isCustom: true,
    classNameTD: 'option-td pe-2',
    dataField: ['dispatch_bill_id'],
    canBeFiltered: true,
    customFormatter: ({ dispatch_bill_id }) => {
      const isBilled =
        dispatch_bill_id &&
        dispatch_bill_id !== 'N/A' &&
        dispatch_bill_id?.id &&
        dispatch_bill_id?.name;
      const statusText = isBilled ? 'Billed' : 'Bill Pending';
      const statusClass = isBilled ? 'received' : 'waiting';
      return (
        <div
          className={`col-${statusClass} pills d-flex ps-2 justify-content-center dispatch-status-pills`}>
          <p>{statusText}</p>
        </div>
      );
    },
  },
  {
    name: 'Dispatch Status',
    classNameTH: 'ps-2 pe-2',
    isCustom: true,
    classNameTD: 'option-td ps-2 pe-2',
    dataField: ['dispatch_status'],

    customFormatter: ({ dispatch_status }) => {
      const statusClass =
        dispatch_status === 'Dispatched'
          ? 'received'
          : dispatch_status === 'Received'
            ? 'dispatched'
            : 'waiting';
      return (
        <div className={`pills col-${statusClass} d-flex ps-2 justify-content-center dispatch-status-pills`}>
          <p>{dispatch_status}</p>
        </div>
      );
    },
  },
  {
    name: 'Status',
    classNameTH: 'ps-2',
    isCustom: true,
    classNameTD: 'option-td ps-2',
    dataField: ['state'],
    customFormatter: ({ state }) => {
      const statusClass =
        state === 'Done' ? 'received' : state === 'Assigned' ? 'dispatched' : 'waiting';
      return (
        <div className={`pills col-${statusClass} d-flex ps-2 justify-content-center dispatch-status-pills`}>
          <p>{state}</p>
        </div>
      );
    },
  },
];

export const BILLS_COLUMN = [
  {
    name: '',
    classNameTH: 'option-td',
    classNameTD: 'option-td',
    dataField: [''],
  },
  {
    name: '*',
    classNameTH: 'option-td',
    classNameTD: 'option-td',
    isCustom: true,
    dataField: ['id'],
    customFormatter: ({
      id,
      func
    }) => {
      return (
        <div className="w-100 h-100 d-flex">
          <input
            className="enable-check"
            disabled={false}
            type="checkbox"
            onChange={() =>
              func.addBillToList({ id })
            }
            checked={func.checked(id)}
          />
        </div>
      );
    },
  },
  {
    name: 'Source',
    classNameTH: 'invoice-th',
    classNameTD: 'invoice-td text-center',
    dataField: ['source'],
    sort: true,
    valueType: 'String',
    canBeFiltered: true,
  },
  {
    name: 'Reference',
    classNameTH: 'invoice-th',
    classNameTD: 'invoice-td text-center',
    dataField: ['draft_number'],
    sort: true,
    valueType: 'String',
    canBeFiltered: true,
  },
  {
    name: 'Lot No',
    classNameTH: 'invoice-th',
    classNameTD: 'invoice-td text-center',
    dataField: ['lot'],
    sort: true,
    valueType: 'Integer',
    canBeFiltered: true,
  },
  {
    name: 'Container No',
    classNameTH: 'invoice-th',
    classNameTD: 'invoice-td text-center',
    dataField: ['container_no'],
    canBeFiltered: true,
    valueType: 'String',
    sort: true,
  },
  {
    name: 'Invoice No',
    classNameTH: 'invoice-th',
    classNameTD: 'invoice-td text-center',
    dataField: ['invoice_no'],
    canBeFiltered: true,
    valueType: 'String',
    sort: true,
  },
  {
    name: 'Invoice Date',
    classNameTH: 'invoice-date-th',
    classNameTD: 'invoice-date-td text-center',
    dataField: ['invoice_date'],
    canBeFiltered: true,
    sort: true,
  },
  {
    name: 'Due Date',
    classNameTH: 'due-date-th',
    classNameTD: 'due-date-td text-center',
    dataField: ['invoice_date_due'],
    canBeFiltered: true,
    sort: true,
  },
  {
    name: 'Amount Due',
    classNameTH: 'amount-due-th',
    classNameTD: 'amount-due-td text-center',
    dataField: ['amount_residual_signed'],
    sort: true,
    valueType: 'Number',
    canBeFiltered: true,
  },
  {
    name: 'Status',
    classNameTH: 'option-td',
    classNameTD: 'option-td text-center',
    dataField: ['state'],
    isCustom: true,
    canBeFiltered: true,
    customFormatter: ({ state }) => {
      const statusMap = {
        Draft: 'dispatched',
        Posted: 'received',
        Cancel: 'waiting',
      };
      const statusClass = statusMap[state];
      return (
        <div className={`pills col-${statusClass} d-flex ps-2 justify-content-center status-pills`}>
          <p>{state}</p>
        </div>
      );
    },
  },
];

export const BILLS_DETAILS_COLUMN = [
  {
    name: '',
    classNameTH: 'product-td',
    classNameTD: 'product-td text-center',
    dataField: [''],
  },
  {
    name: 'Product',
    classNameTH: 'product-td',
    classNameTD: 'product-td text-center',
    dataField: ['product'],
    showFull: true
  },
  {
    name: 'Size',
    classNameTH: 'product-td',
    classNameTD: 'product-td text-center',
    dataField: ['variant_size'],
    valueType: 'Size',
    sort: true,
  },
  {
    name: 'Color',
    classNameTH: 'product-td',
    classNameTD: 'product-td text-center',
    dataField: ['variant_color'],
    valueType: 'String',
    sort: true,
  },
  {
    name: 'Lot No',
    classNameTH: 'product-td',
    classNameTD: 'product-td text-center',
    dataField: ['lot_no'],
    valueType: 'Number',
    sort: true,
  },
  {
    name: 'Quantity',
    classNameTH: 'quantity-td',
    classNameTD: 'quantity-td text-center',
    dataField: ['qty'],
    sort: true,
    valueType: 'Number',
  },
  {
    name: 'UoM',
    classNameTH: 'uom-td',
    classNameTD: 'uom-td text-center',
    dataField: ['uom'],
  },
  {
    name: 'Price',
    classNameTH: 'price-td',
    classNameTD: 'price-td text-center',
    dataField: ['unit_price'],
    sort: true,
    valueType: 'Number',
  },
  {
    name: 'Tax',
    classNameTH: 'tax-td',
    classNameTD: 'tax-td text-center',
    dataField: ['tax'],
    valueType: 'Number',
    sort: true,
  },
  {
    name: 'SubTotal',
    classNameTH: 'tax-excl-td',
    classNameTD: 'tax-excl-td text-center',
    dataField: ['subtotal'],
    valueType: 'Number',
    sort: true,
  },
  {
    name: 'Action',
    classNameTH: 'actions-td',
    classNameTD: 'actions-td text-center',
    dataField: ['type', 'vendor_cost_line_id', 'product', 'qty', 'unit_price'],
    isCustom: true,
    customFormatter: ({
      popUp,
      setPopUp,
      setPopUpData,
      type,
      vendor_cost_line_id,
      product,
      qty,
      unit_price,
    }) => {
      return (
        <ActionBoxBills
          setPopUpData={setPopUpData}
          popUp={popUp}
          setPopUp={setPopUp}
          type={type}
          vendor_cost_line_id={vendor_cost_line_id}
          product={product}
          qty={qty}
          unit_price={unit_price}
        />
      );
    },
  },
];

export const BATCH_COLUMN = [
  {
    name: 'Action',
    classNameTh: '',
    classNameTd: '',
    isClickable: true,
    isCustom: true,
    dataField: ['state', 'order_unit', 'ready_unit'],
    customFormatter: ({ state, order_unit, ready_unit }) => {
      return state === 'packed' ? (
        <Packages width={'18'} height={'18'} />
      ) : ready_unit >= order_unit ? (
        '-'
      ) : (
        <EditIcon />
      );
    },
  },
  {
    name: 'Report',
    classNameTh: '',
    classNameTd: '',
    isCustom: false,
    dataField: ['name'],
    hideIfDye: false,
  },
  {
    name: 'Lot No',
    classNameTh: '',
    classNameTd: '',
    isCustom: false,
    dataField: ['lot'],
    hideIfDye: false,
  },
  {
    name: 'Cut Qty',
    classNameTh: '',
    classNameTd: '',
    isCustom: false,
    dataField: ['cut_qty'],
    hideIfDye: false,
  },
  {
    name: 'Damage Cut Qty',
    classNameTh: '',
    classNameTd: '',
    isCustom: false,
    dataField: ['cut_damage_qty'],
    hideIfDye: false,
  },
  {
    name: 'Cut Date',
    classNameTh: '',
    classNameTd: '',
    isDate: true,
    dataField: ['cut_date'],
    hideIfDye: false,
  },
  {
    name: 'Sew Qty',
    classNameTh: '',
    classNameTd: '',
    isCustom: false,
    dataField: ['sew_qty'],
    hideIfDye: false,
  },
  {
    name: 'Damage Sew Qty',
    classNameTh: '',
    classNameTd: '',
    isCustom: false,
    dataField: ['sew_damage_qty'],
    hideIfDye: false,
  },
  {
    name: 'Sew Date',
    classNameTh: '',
    classNameTd: '',
    isDate: true,
    dataField: ['sew_date'],
    hideIfDye: false,
  },
  {
    name: 'Packed Qty',
    classNameTh: '',
    classNameTd: '',
    isCustom: false,
    dataField: ['pack_qty'],
    hideIfDye: true,
  },
  {
    name: 'Packed Date',
    classNameTh: '',
    classNameTd: '',
    isDate: true,
    dataField: ['pack_date'],
    hideIfDye: true,
  },
  {
    name: 'Completed',
    classNameTh: '',
    classNameTd: '',
    isCustom: true,
    hideIfDye: false,
    dataField: ['state'],
    customFormatter: ({ state }) => {
      return (
        <div
          className={`${state === 'packed' ? 'green' : 'orange'}-active w-auto d-flex align-items-center justify-content-center`}>
          {state === 'packed' ? 'completed' : 'In Progress'}
        </div>
      );
    },
  },
];

export const BLP_COLUMNS = [
  {
    name: 'No',
    classNameTh: '',
    classNameTd: '',
    dataField: ['id'],
  },
  {
    name: 'BLP No',
    classNameTh: '',
    classNameTd: '',
    dataField: ['name'],
  },
  {
    name: 'SKU',
    classNameTh: '',
    classNameTd: '',
    dataField: ['sku'],
  },
  {
    name: 'Qty/Box',
    classNameTh: '',
    classNameTd: '',
    dataField: ['qty'],
  },
];

export const PRODUCTION_COLUMN = [
  {
    name: '',
    classNameTH: 'option-td',
    classNameTD: 'option-td',
    dataField: [''],
  },
  {
    name: '*',
    classNameTH: 'option-td',
    classNameTD: 'option-td',
    isCustom: true,
    dataField: ['id', 'state'],
    customFormatter: ({ id, state, func }) => {
      const disabled = (state === 'Done' || state === 'Cancel');
      const isInProgress = func.isInProgress(id);
      const pickStatus = capitalize(func?.getPickingStatus?.(id));
      const isDisabled = disabled || isInProgress || (pickStatus === 'Done');
      return (
        <div className="w-100 h-100 d-flex">
          <input
            className={
              isDisabled ? 'disable-check' : 'enable-check'
            }
            type="checkbox"
            disabled={isDisabled}
            onChange={() => func.addBulkMO({ id })}
            checked={!isDisabled && func.checked(id)}
          />
        </div>
      );
    }
  },
  {
    name: 'Source',
    classNameTH: 'option-th',
    classNameTD: 'option-td',
    sort: true,
    valueType: 'String',
    dataField: ['origin'],
  },
  {
    name: 'Lot No',
    classNameTH: 'option-th',
    classNameTD: 'option-td',
    valueType: 'String',
    sort: true,
    dataField: ['lot'],
  },
  {
    name: 'Lot Color',
    classNameTH: 'option-th',
    classNameTD: 'option-td',
    isCustom: false,
    dataField: ['lot_color'],
    valueType: 'String',
    sort: true,
  },
  {
    name: 'Lot Size',
    classNameTH: 'option-th',
    classNameTD: 'option-td',
    isCustom: false,
    dataField: ['lot_size'],
    valueType: 'String',
    sort: true,
  },
  {
    name: 'Rib Color',
    classNameTH: 'option-th',
    classNameTD: 'option-td',
    isCustom: false,
    dataField: ['rib_color'],
    valueType: 'String',
    sort: true,
  },
  {
    name: 'Rib Size',
    classNameTH: 'option-th',
    classNameTD: 'option-td',
    isCustom: false,
    dataField: ['rib_size'],
    valueType: 'String',
    sort: true,
  },
  {
    name: 'Backorder Of',
    classNameTH: 'option-th',
    classNameTD: 'option-td',
    valueType: 'String',
    sort: true,
    dataField: ['backorder_of'],
  },
  {
    name: 'Finished Product',
    classNameTH: 'option-td',
    classNameTD: 'option-td',
    sort: true,
    valueType: 'String',
    dataField: ['finished_product'],
  },
  {
    name: 'Date',
    classNameTH: 'option-th',
    classNameTD: 'option-td',
    dataField: ['shipment_date'],
    sort: true,
  },
  {
    name: 'Priority',
    classNameTH: 'option-th',
    classNameTD: 'option-td',
    dataField: ['priority'],
    valueType: 'String',
    sort: true,
  },
  {
    name: 'Status',
    classNameTH: '',
    isCustom: true,
    classNameTD: 'option-td',
    dataField: ['id', 'state'],
    customFormatter: ({ id, state, func }) => {
      const statusMap = {
        Done: 'received',
        Assigned: 'dispatched',
        Cancel: 'waiting',
      };

      const pickStatus = capitalize(func?.getPickingStatus?.(id));
      const effectiveState = pickStatus || state;

      const statusClass = statusMap[effectiveState] || '';

      // Check if this record is in progress
      const isInProgress = func?.isInProgress?.(id);

      return (
        <div className="d-flex justify-content-center align-items-center" style={{ height: '100%' }}>
          {isInProgress ? (
            <span className="spinner-border spinner-border-sm text-primary" role="status" aria-hidden="true"></span>
          ) : (
            <div className={`pills col-${statusClass} d-flex ps-2 justify-content-center status-pills`}>
              <p>{effectiveState}</p>
            </div>
          )}
        </div>
      );
    },
  },
];

export const MANUFACTURING_ESUN_LIST_COLUMN = [
  {
    name: '',
    classNameTH: 'option-td',
    classNameTD: 'option-td',
    dataField: [''],
  },
  {
    name: 'Future Lot',
    classNameTH: 'option-th',
    classNameTD: 'option-td',
    sort: true,
    valueType: 'String',
    dataField: ['lot_no'],
  },
  {
    name: 'SKU Code',
    classNameTH: 'option-th',
    classNameTD: 'option-td',
    valueType: 'String',
    sort: true,
    dataField: ['SKU'],
  },
  // {
  //   name: 'Finished Product',
  //   classNameTH: 'option-td',
  //   classNameTD: 'option-td',
  //   sort: true,
  //   valueType: 'String',
  //   dataField: ['finished_product'],
  // },
  {
    name: 'Ordered Quantity',
    classNameTH: 'option-th',
    classNameTD: 'option-td',
    dataField: ['total_qty'],
    valueType: 'Integer',
    sort: true,
    zeroFirst: true,
  },
  {
    name: 'Ready Quantity',
    classNameTH: 'option-th',
    classNameTD: 'option-td',
    dataField: ['ready_qty'],
    valueType: 'Integer',
    sort: true,
    zeroFirst: true,
  },
  {
    name: 'Priority',
    classNameTH: 'option-th',
    classNameTD: 'option-td',
    sort: true,
    valueType: 'String',
    dataField: ['priority'],
  },
  {
    name: 'Qty Status',
    classNameTH: '',
    isCustom: true,
    classNameTD: 'option-td',
    dataField: ['qty_status_list'],
    customFormatter: ({ qty_status_list }) => {
      const statusClass =
        qty_status_list === 'Done'
          ? 'received'
          : qty_status_list === 'Partial'
            ? 'dispatched'
            : 'waiting';
      return (
        <div className={`pills col-${statusClass} d-flex ps-2 justify-content-center status-pills`}>
          <p>{qty_status_list}</p>
        </div>
      );
    },
  },
  {
    name: 'Ready Status',
    classNameTH: '',
    isCustom: true,
    classNameTD: 'option-td',
    dataField: ['ready_status'],
    customFormatter: ({ ready_status }) => {
      const statusClass =
        ready_status === 'Not Ready'
          ? 'waiting'
          : ready_status === 'Partially Ready'
            ? 'dispatched'
            : 'received';
      return (
        <div className={`pills col-${statusClass} d-flex ps-2 justify-content-center status-pills`}>
          <p>{ready_status}</p>
        </div>
      );
    },
  },
];

export const FABRIC_PRODUCTION_DETAILS_COLUMN = [
  {
    name: '',
    classNameTH: 'option-td',
    classNameTD: 'option-td',
    dataField: [''],
  },
  {
    name: 'Product',
    classNameTH: 'product-td',
    classNameTD: 'product-td text-center',
    dataField: ['product'],
    showFull: true
  },
  {
    name: 'Lot No',
    classNameTH: 'lotno-td',
    classNameTD: 'lotno-td text-center',
    sort: true,
    valueType: 'Number',
    dataField: ['lotno'],
  },
  {
    name: 'Size',
    classNameTH: 'lotno-td',
    classNameTD: 'lotno-td text-center',
    dataField: ['size'],
    valueType: 'Number',
    sort: true,
  },
  {
    name: 'Color',
    classNameTH: 'lotno-td',
    classNameTD: 'lotno-td text-center',
    dataField: ['color'],
    valueType: 'String',
    sort: true,
  },
  {
    name: 'Demand Quantity',
    classNameTH: 'demand-quantity-td',
    classNameTD: 'demand-quantity-td text-center',
    sort: true,
    valueType: 'Number',
    dataField: ['demand_quantity'],
  },
  {
    name: 'Produced Quantity',
    classNameTH: 'producing-quantity-td',
    classNameTD: 'producing-quantity-td text-center',
    sort: true,
    valueType: 'Number',
    dataField: ['producing_quantity'],
  },
  {
    name: 'Damaged Quantity',
    classNameTH: 'producing-quantity-td',
    classNameTD: 'producing-quantity-td text-center',
    sort: true,
    valueType: 'Number',
    dataField: ['manufacture_damage_qty'],
  },
  {
    name: 'Produced Qty',
    classNameTH: 'producing-quantity-td',
    classNameTD: 'producing-quantity-td text-center',
    sort: true,
    valueType: 'Number',
    dataField: ['draft_produced_qty'],
  },
  {
    name: 'Damaged Qty',
    classNameTH: 'producing-quantity-td',
    classNameTD: 'producing-quantity-td text-center',
    sort: true,
    valueType: 'Number',
    dataField: ['draft_damaged_qty'],
  },
  {
    name: 'Rolls',
    classNameTH: 'received-quantity-td',
    classNameTD: 'received-quantity-td text-center',
    sort: true,
    valueType: 'Number',
    dataField: ['rolls'],
  },
  {
    name: 'Unit',
    classNameTH: 'unit-td',
    classNameTD: 'unit-td text-center',
    dataField: ['unit'],
  },
  {
    name: 'Ready Status',
    classNameTH: 'unit-td',
    classNameTD: 'unit-td text-center',
    sort: true,
    valueType: 'String',
    dataField: ['ready_status'],
  },
  {
    name: 'Action',
    classNameTH: 'actions-td',
    classNameTD: 'actions-td text-center',
    dataField: [
      'demand_quantity',
      'material',
      'subcontract',
      'lotno',
      'producing_quantity',
      'move_id',
      'tracking',
      'state',
      'damaged_quantity',
      'ready_status',
    ],
    isCustom: true,
    customFormatter: ({
      popUp,
      setPopUp,
      setPopUpData,
      demand_quantity,
      lotno,
      producing_quantity,
      subcontract,
      move_id,
      tracking,
      material,
      state,
      damaged_quantity,
      ready_status,
    }) => {
      return (
        <ActionBox1
          setPopUpData={setPopUpData}
          popUp={popUp}
          setPopUp={setPopUp}
          data={{
            tracking,
            material,
            subcontract,
            demand_quantity,
            lotno,
            producing_quantity,
            move_id,
            state,
            damaged_quantity,
            ready_status,
          }}
        />
      );
    },
  },
  {
    name: 'Clear',
    classNameTH: 'actions-td',
    classNameTD: 'actions-td text-center',
    dataField: ['move_id'],
    isCustom: true,
    customFormatter: ({ move_id, setUpdatedMoves, setEditedQuantities }) => {

      return (
        <ActionBoxClear
          moveId={move_id}
          setUpdatedMoves={setUpdatedMoves}
          setEditedQuantities={setEditedQuantities}
        />
      );
    },
  },

];

export const REPORTS_COLUMN = [
  {
    name: '',
    classNameTH: 'option-th',
    classNameTD: 'option-td',
    dataField: [''],
  },
  {
    name: 'Source',
    classNameTH: 'option-th',
    classNameTD: 'option-td',
    dataField: ['po'],
    valueType: 'String',
    sort: true,
  },
  {
    name: 'Lot No',
    classNameTH: 'option-th',
    classNameTD: 'option-td',
    dataField: ['lot'],
    valueType: 'String',
    sort: true,
  },
  {
    name: 'PF Name',
    classNameTH: 'product-name-th',
    classNameTD: 'product-name-td',
    dataField: ['pf_name'],
    showFull: true,
  },
  {
    name: 'PF Ordered Qty',
    classNameTH: 'option-th',
    classNameTD: 'option-td',
    dataField: ['pf_ordered_qty'],
    valueType: 'Integer',
    sort: true,
  },
  {
    name: 'PF Produced Qty',
    classNameTH: 'option-th',
    classNameTD: 'option-td',
    dataField: ['pf_produced_qty'],
    valueType: 'Integer',
    sort: true,
  },
  {
    name: 'PF Produced Date',
    classNameTH: 'option-th',
    classNameTD: 'option-td',
    dataField: ['pf_produced_date'],
    valueType: 'Date',
    sort: true,
  },
  {
    name: 'RIB Name',
    classNameTH: 'product-name-th',
    classNameTD: 'product-name-td',
    dataField: ['rib_name'],
    showFull: true,
  },
  {
    name: 'RIB Ordered Qty',
    classNameTH: 'option-th',
    classNameTD: 'option-td',
    dataField: ['rib_ordered_qty'],
    valueType: 'Integer',
    sort: true,
  },
  {
    name: 'RIB Produced Qty',
    classNameTH: 'option-th',
    classNameTD: 'option-td',
    dataField: ['rib_produced_qty'],
    valueType: 'Integer',
    sort: true,
  },
  {
    name: 'RIB Produced Date',
    classNameTH: 'option-th',
    classNameTD: 'option-td',
    dataField: ['rib_produced_date'],
    valueType: 'Date',
    sort: true,
  },
  {
    name: 'IP Name',
    classNameTH: 'product-name-th',
    classNameTD: 'product-name-td',
    dataField: ['ip_name'],
    showFull: true,
  },
  {
    name: 'IP Ordered Qty',
    classNameTH: 'option-th',
    classNameTD: 'option-td',
    dataField: ['ip_ordered_qty'],
    valueType: 'Integer',
    sort: true,
  },
  {
    name: 'IP Cut Qty',
    classNameTH: 'option-th',
    classNameTD: 'option-td',
    dataField: ['ip_cut_qty'],
    valueType: 'Integer',
    sort: true,
  },
  {
    name: 'IP Cut Date',
    classNameTH: 'option-th',
    classNameTD: 'option-td',
    dataField: ['ip_cut_date'],
    valueType: 'Date',
    sort: true,
  },
  {
    name: 'IP Sew Qty',
    classNameTH: 'option-th',
    classNameTD: 'option-td',
    dataField: ['ip_sew_qty'],
    valueType: 'Integer',
    sort: true,
  },
  {
    name: 'IP Sew Date',
    classNameTH: 'option-th',
    classNameTD: 'option-td',
    dataField: ['ip_sew_date'],
    sort: true,
  },
  {
    name: 'FP Name',
    classNameTH: 'product-name-th',
    classNameTD: 'product-name-td',
    dataField: ['fp_name'],
    showFull: true,
  },
  {
    name: 'FP Ordered Qty',
    classNameTH: 'option-th',
    classNameTD: 'option-td',
    dataField: ['fp_ordered_qty'],
    valueType: 'Integer',
    sort: true,
  },
  {
    name: 'FP Cut Qty',
    classNameTH: 'option-th',
    classNameTD: 'option-td',
    dataField: ['fp_cut_qty'],
    valueType: 'Integer',
    sort: true,
  },
  {
    name: 'FP Cut Date',
    classNameTH: 'option-th',
    classNameTD: 'option-td',
    dataField: ['fp_cut_date'],
    valueType: 'Date',
    sort: true,
  },
  {
    name: 'FP Sew Qty',
    classNameTH: 'option-th',
    classNameTD: 'option-td',
    dataField: ['fp_sew_qty'],
    valueType: 'Integer',
    sort: true,
  },
  {
    name: 'FP Sew Date',
    classNameTH: 'option-th',
    classNameTD: 'option-td',
    dataField: ['fp_sew_date'],
    valueType: 'Date',
    sort: true,
  },
  {
    name: 'FP Packed Qty',
    classNameTH: 'option-th',
    classNameTD: 'option-td',
    dataField: ['fp_packed_qty'],
    valueType: 'Integer',
    sort: true,
  },
  {
    name: 'FP Packed Date',
    classNameTH: 'option-th',
    classNameTD: 'option-td',
    dataField: ['fp_packed_date'],
    valueType: 'Date',
    sort: true,
  },
];

export const SKU_COLUMN = [
  {
    name: 'SKU',
    classNameTH: 'd-flex justify-content-start px-5 ',
    classNameTD: 'd-flex justify-content-start align-items-center px-5 border ',
    dataField: ['name'],
  },
  {
    name: 'Quantity',
    classNameTH: 'option-th',
    classNameTD: 'option-td border',
    dataField: ['quantity'],
  },
  {
    name: 'Action',
    classNameTH: 'd-flex justify-content-center ',
    classNameTD: 'option-td border',
    isCustom: true,
    dataField: ['id', 'name', 'quantity'],
    customFormatter: ({ id, name, quantity, func }) => {
      return (
        <div className="d-flex justify-content-evenly h-100 align-items-center gap-3">
          <div
            onClick={() => {
              func({ data: { id, name, quantity }, action: 'edit' });
            }}
            className="w-50 h-100 m-0 d-flex align-items-center justify-content-center action-div-3">
            <EditIcon />
          </div>
          <div
            onClick={() => {
              func({ data: { id, name, quantity }, action: 'delete' });
            }}
            className="w-50 h-100 m-0 d-flex align-items-center justify-content-center action-div-3">
            <DeleteRedIcon />
          </div>
        </div>
      );
    },
  },
];
